import { selectTPNoteState } from "@ispm-client/modules/pathway-selections/store/selectors/pathway-selections.selector";

export const SelectorsMapping = {
    "selectTPNoteState": selectTPNoteState
}